import React from 'react'
import ReactOnRails from "react-on-rails/client";

import LanguageSelect from 'frontend/Navigation/LanguageSelect'
import PopularLocations from 'frontend/Navigation/PopularLocations'
import Cookies from 'frontend/Navigation/Cookies'
import MobileMenu from 'frontend/Navigation/MobileMenu'

ReactOnRails.register({LanguageSelect, PopularLocations, Cookies, MobileMenu})